{
  "es": {
    "issue": {
      "actions": {
        "approve_for_customer": "Aprobar para el cliente",
        "assign": "Asignar",
        "collapse": "Contraer incidencias",
        "create_category": "Añadir nueva categoría",
        "create_issue": "Crear incidencia",
        "create_issue_customer": "Notificar incidencia",
        "delete": "Eliminar incidencia",
        "expand": "Expandir incidencias",
        "export_images": "Descargar imágenes",
        "hideActivity": "Ocultar actividad",
        "openConversation": "Abrir conversación",
        "reject_for_customer": "Rechazar para el cliente",
        "show": "Mostrar incidencia",
        "showActivity": "Mostrar actividad",
        "startConversation": "Iniciar conversación",
        "start_conversation": "Iniciar conversación sobre esta incidencia",
        "undo_customer_approval": "Deshacer la aprobación del cliente",
        "undo_customer_rejection": "Deshacer el rechazo del cliente",
        "update": "Actualizar incidencias"
      },
      "attributes": {
        "approval_status": "Aprobación del cliente",
        "assignee": "Responsable",
        "category": "Categoría",
        "created_at": "Creada",
        "deadline": "Fecha límite",
        "description": "Descripción",
        "issue_list_type": "Lista de incidencias",
        "name": "Nombre",
        "responsible": "Responsable",
        "status": "Estado",
        "statuses": {
          "approval_not_requested": "No solicitada",
          "approval_requested": "Solicitada",
          "approved": "Aprobada",
          "completed": "Completada",
          "created": "Abierta",
          "declined": "Rechazada",
          "inbox": "Enviada",
          "not_completed": "Sin completar",
          "ongoing": "En curso"
        },
        "updated_at": "Última actualización"
      },
      "edit_actions": {
        "edit_category": "Categoría",
        "edit_deadline": "Fecha límite",
        "edit_issue_list_type": "Lista de incidencias",
        "edit_responsible": "Responsable",
        "edit_status": "Estado"
      },
      "labels": {
        "activity": "Mostrar actividad",
        "addImagesSubtitle": "Una imagen vale más que mil palabras",
        "addImagesTitle": "Añade imágenes para ayudarnos a entender mejor la incidencia",
        "after_care_page_title": "Tus incidencias",
        "all_categories_can_be_managed_under": "Todas las categorías se pueden gestionar en",
        "approvalNotRequested": "Aprobación no solicitada",
        "approvalRequested": "Aprobación solicitada",
        "approved": "Aprobada",
        "approvedInfo": "El cliente aprobó esta incidencia",
        "assignee": "Responsable",
        "cancelCustomerApproval": "Cancelar solicitud de aprobación del cliente",
        "collapse": "Ocultar actividad",
        "company_settings": "ajustes de la organización",
        "count_edit": "Editar incidencia | Editar {count} incidencias",
        "create_new_category?": "¿No encuentras la categoría que necesitas? ¡Crea una nueva!",
        "created_at": "Creada el",
        "customerApproved": "Aprobada por el cliente",
        "customerRejected": "Rechazada por el cliente",
        "deadline_date": "Fecha límite",
        "description": "Descripción",
        "descriptionSubtitle": "Usa viñetas y frases cortas para ayudarnos a entender mejor la incidencia",
        "descriptionTitle": "Escribe una breve descripción",
        "edit_category": "Editar categoría",
        "edit_issue": "Editar incidencia",
        "isThisPointFixed": "¿Crees que esto está solucionado?",
        "issue_category_name": "Categoría",
        "issue_status_name": "Estado",
        "issues_clear_selection": "Limpiar selección",
        "issues_select_all_pages": "Seleccionar las {total} incidencias",
        "issues_select_one": "Selecciona al menos 1 incidencia",
        "issues_selected": "incidencias seleccionadas",
        "issues_selected_all_pages": "Las {total} incidencias seleccionadas",
        "issues_selected_count": "{selected} incidencia seleccionada | {selected} incidencias seleccionadas",
        "name": "Nombre",
        "new": "Crear nueva incidencia",
        "new_category": "Nueva categoría",
        "noDescriptionYet": "Todavía no hay descripción",
        "no_issue_deadline": "No hay fecha límite establecida",
        "no_issues": "No hay incidencias",
        "no_responsible": "Sin responsable",
        "origin": "Origen",
        "reason": "Motivo",
        "redoRequest": "Repetir solicitud",
        "requestCustomerApproval": "Solicitar aprobación del cliente",
        "requested": "Solicitada",
        "requestedInfo": "Aprobación del cliente solicitada",
        "resetRequest": "Restablecer solicitud",
        "responsible_of_Employee_type_last_name_or_responsible_of_Partner_type_last_name": "Responsable",
        "return_to_overview": "Volver",
        "showIssuesfor": "Mostrar incidencias de",
        "statusExplained": "Qué significa cada color de estado",
        "subjectSubtitle": "Solo se necesita 1 notificación por incidencia. Nosotros nos encargamos del resto",
        "subjectTitle": "Describe la incidencia en pocas palabras",
        "unit_issues_will_be_shown_here": "Aquí aparecerán todas las unidades vinculadas a la lista de incidencias",
        "unit_name": "Nombre de la unidad",
        "updated_at": "Última actualización",
        "waitingForApproval": "Esta incidencia debe ser aceptada por {client_name} antes de que puedas iniciar una conversación",
        "whyIsThisPointNotFixed": "¿Por qué no está solucionada esta incidencia?",
        "youApprovedThisPoint": "Solucionada según tú",
        "youRejectedThisPoint": "No solucionada según tú"
      },
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Te avisaremos si se notifica una nueva incidencia.",
            "title": "Todavía no se ha notificado ninguna incidencia para tu unidad"
          }
        },
        "employees": {
          "inbox": {
            "subtitle": "Cuando los clientes creen nuevas incidencias, aparecerán aquí de nuevo.",
            "title": "Has procesado todas las incidencias entrantes de los clientes"
          },
          "none": {
            "subtitle": "Empieza a registrar lo que hay que arreglar o mejorar",
            "title": "Crea tu primera incidencia"
          },
          "overview": {
            "subtitle": "Crea tu primera incidencia dentro de una unidad para empezar",
            "title": "Aquí aparecerán las incidencias creadas en todas tus unidades"
          },
          "unit": {
            "title": "Aquí aparecerán todas las incidencias de esta unidad"
          }
        },
        "partners": {
          "none": {
            "subtitle": "En cuanto se te asignen incidencias, aparecerán aquí",
            "title": "Todavía no tienes incidencias asignadas"
          }
        }
      },
      "sortGroups": {
        "date": "Fecha",
        "deadline": "Fecha límite",
        "name": "Nombre"
      },
      "toasts": {
        "update": "Incidencia actualizada"
      },
      "validation": {
        "issue_list_type_required": "La lista de incidencias es obligatoria",
        "pleaseProvideAReason": "Indica un motivo.",
        "status_required": "El estado es obligatorio"
      }
    }
  }
}
